import { NgModule }           from '@angular/core';

//import the shared functionality module
import { SharedModule }       from '../shared/shared.module';

//import location specific stuff
import { LocationSearchComponent }   from './locationsearch.component';
// import { LocationService }     from './locationsearch.service';

@NgModule({
  imports:      [
    SharedModule
    ],
  declarations: [ LocationSearchComponent ],
  // providers:    [ LocationService ],
  exports: [LocationSearchComponent]
})
export class LocationSearchModule { }


// WEBPACK FOOTER //
// ./app/location-search/locationsearch.module.ts